import React from 'react';
import ComplyAdvantage from './comply_advantage.png';
import LTI from './lti.png';

export default [
    {
        title: 'Comply Advantage',
        image: ComplyAdvantage,
        content: [
            <p key="1">
                ComplyAdvantage helps firms make intelligent choices when
                complying with regulations relating to sanctions, money
                laundering and terrorist financing.
            </p>,
            <p key="2">
                We combine Artificial Intelligence and machine learning with
                industry expertise to allow firms to tailor a risk-based
                approach to their compliance obligations. Our solutions enable
                companies to improve how they onboard and monitor clients,
                screen payments and monitor transactions by reducing false
                positives and speeding up processes, all delivered by flexible,
                RESTful APIs.
            </p>,
            <p key="3">
                Founded in 2014 with offices in London and New York,
                ComplyAdvantage works globally with some 350 firms in the
                financial markets and and other regulated high-risk sectors.
            </p>,
        ],
    },
    {
        title: "LTI, Let's Solve",
        image: LTI,
        content: [
            <p key="1">
                LTI (NSE: LTI, BSE: 540005) is a global technology consulting
                and digital solutions Company helping more than 300 clients
                succeed in a converging world. With operations in 27 countries,
                we go the extra mile for our clients and accelerate their
                digital transformation with LTI’s Mosaic platform enabling their
                mobile, social, analytics, IoT and cloud journeys.
            </p>,
            <p key="2">
                Founded 20 years ago as a subsidiary of Larsen & Toubro Limited,
                our unique heritage gives us unrivaled real-world expertise to
                solve the most complex challenges of enterprises across all
                industries.
            </p>,
            <p key="3">
                Each day, our team of more than 24,000 LTItes enable our clients
                to improve the effectiveness of their business and technology
                operations, and deliver value to their customers, employees and
                shareholders. Find more at
                <a href="https://www.Lntinfotech.com"> www.Lntinfotech.com</a>.
            </p>,
        ],
    },
];



// WEBPACK FOOTER //
// ./src/components/sections/content/partners/index.js